// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>12</span>&nbsp;&nbsp;O grant us your help against the enemy,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for earthly help is in vain.<br> </p> </div></div>";
// Exports
module.exports = code;